<template>
  <div>
    <b-dropdown @show="popup">
      <template v-slot:button-content>
        <img :src="valueImg" :style="{ width, height }">
      </template>
    </b-dropdown>
    <transition name="modal">
      <div v-if="showModal">
        <div class="modal-mask" @click="showModal = false">
          <vue-select-image class="modal-list" :dataImages="iconList"
            @onselectimage="onSelectImage"
            :w="width" :h="height"
          >
          </vue-select-image>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
export default {
  name: 'icon-dropdown',
  computed: {
    valueImg () {
      return this.value ? this.iconMap[this.value] : this.noimage
    }
  },
  data () {
    return {
      localValue: this.value,
      showModal: false,
      iconMap: {},
      iconList: [],
      valueIcon: null,
      noimage: require('@/assets/noimage.png')
    }
  },
  methods: {
    popup (e) {
      this.showModal = true
      e.preventDefault()
    },
    onSelectImage (e) {
      this.localValue = e.id
      this.$emit('input', e.id)
      this.showModal = false
    },
    mapping (list) {
      list.forEach((elm) => {
        this.$set(this.iconMap, elm.value, elm.url || this.noimage)
        this.iconList.push({ id: elm.value, src: elm.url || this.noimage })
      })
    }
  },
  mounted () {
    this.$watch('list', function (newVal) {
      this.mapping(newVal)
    })
    this.mapping(this.list)
    this.$watch('showModal', (newVal) => {
      if(newVal) {
        disableBodyScroll()
      } else {
        enableBodyScroll()
      }
      return newVal
    })
  },
  props: {
    list: Array,
    value: String,
    width: { type: String, default: 'auto' },
    height: { type: String, default: 'auto' }
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  // display: table;
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-list {
  z-index: 9999;
}

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
